<template>
    <div>
        <router-view name="header-top"></router-view>
        <router-view/>
        <router-view name="footer"></router-view>
    </div>
</template>

<script>
import Header from '@Common/Header.vue'
import SideMenu from '@Common/SideMenu.vue'
import { axiosRequests } from '@ClientPortal/main.js'

export default {
    created () {
        if(this.securityProfile.includes('security-okta')){
            this.isAuthenticated()
            this.setup()
            this.$auth.authStateManager.subscribe(this.isAuthenticated)
        }
        else if(this.securityProfile.includes('security-db')){
            const token = localStorage.getItem("token")
            axiosRequests.defaults.headers.authorization = token
            
            axiosRequests.get().then((resp)=>{
                if(resp.status == 200){
                    this.$store.dispatch('loginFromToken', { token })
                    this.authenticated = true
                }
            }).catch(() =>{
                    this.$store.dispatch('logout')
                    this.$store.dispatch('setSystemMessage', {message: "You have been logged out. Please enter your credentials."})
                    this.authenticated = false
                }
            )

        } 
        //security-off profile default behaviour
        else {
            // TODO: Use webpack to strip this code block in production
            axiosRequests.get().then(
            (resp)=>{
                    // If authorization header is empty and resp is 200, security-off profile is active
                    if(resp.status == 200){
                        const token = "STUB-JWT.eyJzdWIiOiIwIiwidXNlcm5hbWUiOiJhZG1pbiIsImF1dGhvcml0aWVzIjpbIlJPTEVfQURNSU4iLCJSRUFEIiwiQ1JFQVRFIiwiREVMRVRFIiwiVVBEQVRFIl19.UNSIGNED"
                        this.$store.dispatch('loginFromToken', { token })
                    }
                    this.authenticated = true
            }).catch(
                () => {
                    this.authenticated = false
                    this.$store.dispatch('logout')
            })
        }
    },
    watch: {
        // Everytime the route changes, check for auth status
        '$route': 'setup',
        '$route' (to, from) {
            document.title = to.name || 'PortfolioWatch'
        }
    },
    data() {
        return { 
            authenticated: false,
            securityProfile: process.env.SECURITY_PROFILE.split(","),
            localStorage: window.localStorage,
            browserUrl: window.location.href
        }
    },
    computed: { 
        route(){
            return this.$route
        }
    },
    components: {
        'app-header': Header,
        'sideMenu': SideMenu
    },
    methods: {
        async isAuthenticated () {
            this.authenticated = await this.$auth.isAuthenticated()
        },
        async setup(){
            if(!this.authenticated && (this.securityProfile.includes('security-okta')))
            {
                const token = await this.$auth.tokenManager.getTokens()
                const claims = await this.$auth.getUser(token.accessToken)
            
                this.$store.dispatch('loginFromOktaToken',{'token': token.accessToken.value,
                    'parsedToken': token.accessToken,  'claims':claims})
            }
        }
    },
    mounted() {
        document.onreadystatechange = () => {
          if (document.readyState == "complete") {
          }
        }
    },
}
</script>

<style scoped>


</style>

<style>
html{
  min-height: 100%;
}
.flex-page {
    display: flex;
    justify-content: space-around;
    margin-top: 6rem;
    padding-top:50px;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 50px;
 }
 .left-column {
  display: flex;
  width: 50vw;
  justify-content: left;
  flex-direction: column;
}

.right-column {
  display: flex;
  width: 50vw;
  justify-content: right;
  flex-direction: column;
  /* margin-top: 3rem; */
}

</style>

// Load external CSS Blocks
<style src="vue-simple-calendar/static/css/default.css"></style>
<style src="vue-simple-calendar/static/css/holidays-us.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

// Load CKM Theme files
<style src="@Style/header.css"></style>
<style src="@Style/sideMenu.css"></style>
<style src="@Style/visualizationContainer.css"></style>

// Load custom App Theme files
<style src="@Style/grid.css"></style>
<style src="@Style/index.css"></style>
<style lang="scss" src="@Style/_index.scss"></style>

//Load PortfolioWatch Specific
<style src="@Style/ckm-style/stylesheets/pw-fonts.css"></style>
<style src="@Style/ckm-style/stylesheets/pw-main.css"></style>
